/** @jsxImportSource @emotion/react */
import React, { ForwardRefRenderFunction, InputHTMLAttributes, ReactElement } from 'react';

import inputStyles from './input.styles';
import closeIcon from '../../assets/icons/close-icon.svg';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label?: string;
    ref?: string;
    icon?: ReactElement;
    showClearIcon?: boolean;
}

const Input: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
    { name, label, icon, showClearIcon = false, value, onChange, ...otherProps },
    ref
) => {
    return (
        <label css={inputStyles.label}>
            {label}
            <div css={inputStyles.icon}>{icon}</div>
            <input
                css={inputStyles.input}
                {...otherProps}
                value={value}
                name={name}
                ref={ref}
                onChange={onChange}
                style={{
                    ...(showClearIcon ? { paddingRight: '40px' } : {}),
                }}
            />
            {showClearIcon && (value as string).length > 0 && (
                <img
                    src={closeIcon}
                    css={inputStyles.clearIcon}
                    onClick={() => onChange?.({ target: { value: '' } } as any)}
                />
            )}
        </label>
    );
};

const FormInput = React.forwardRef(Input);

export default FormInput;
